import INTL_FORMATS from './config/intl-formats';

const defaultLocaleData = {
  INTL_FORMATS,
};

export default defaultLocaleData;
